import "./vendor/jquery.swiftype.autocomplete";

// https://app.swiftype.com/engines/archived-singlestore-documentation/overview
const ENGINE_KEY = "aaaz_zgMnxko6VRzSH3q";

export default class Search {
    itemListRenderFunction(ctx, results) {
        var $list = ctx.list,
            config = ctx.config;

        $.each(results, function (documentType, items) {
            $.each(items, function (idx, item) {
                var anchorLi = $(
                    `<a class="autocomplete-item" href="${
                        item.url
                    }">${config.renderFunction(documentType, item)}</a>`
                );
                ctx.registerResult(anchorLi.appendTo($list), item);
            });
        });
    }

    singleItemRenderFunction(type, item) {
        const displayFields = ["title", "sections"];

        return displayFields
            .map(
                (field) =>
                    `<span class="${field}">${
                        item.highlight[field] || item[field]
                    }</span>`
            )
            .join("");
    }

    getEngineKey() {
        return ENGINE_KEY;
    }

    addEventListeners({
        inputSelector,
        smallScreenWidth,
        navbarComponentRoot,
        autoCompleteSelector,
    }) {
        const $clearBtn = $(".search-box > .clear-button");
        const $searchBox = $(".search-box");
        const $dropdown = $(".autocomplete-item-list");
        const $body = $("body");
        const $autocomplete = $(autoCompleteSelector);
        const $navbar = $(navbarComponentRoot);

        $clearBtn.mousedown(() => $(inputSelector).val(""));

        $searchBox.mouseenter(() => {
            if ($(inputSelector).val() !== "") {
                $clearBtn.show();
            }
        });

        $searchBox.mouseleave(() => {
            if (!$(inputSelector).is(":focus")) {
                $clearBtn.hide();
            }
        });

        $(inputSelector).focus(() => {
            if ($(inputSelector).val() !== "") {
                $clearBtn.show();
            }

            $autocomplete.css({
                "top": `${$navbar.outerHeight() + $searchBox.outerHeight()}px`
            });

            // On mobile, set the dropdown to cover the area from the header down
            if (window.innerWidth < smallScreenWidth) {
                const headerHeight = $(navbarComponentRoot).outerHeight();
                const searchboxHeight = $searchBox.outerHeight();

                $dropdown.css({
                    "max-height": `${window.innerHeight - headerHeight - searchboxHeight}px`,
                });
            }
        });

        $(inputSelector).blur(() => $clearBtn.hide());

        $(inputSelector).on("input keyup propertychange", () => {
            $(inputSelector).val() !== "" ? $clearBtn.show() : $clearBtn.hide();
        });

        // Freeze the body when the dropdown is open
        if (MutationObserver) {
            const autocompleteObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const $target = $(mutation.target);

                    const hasDisplayNone = $target.css("display") === "none";
                    const overflow = hasDisplayNone ? "auto" : "hidden";

                    $body.css({ overflow });
                });
            });

            if ($dropdown.get(0)) {
                autocompleteObserver.observe($dropdown.get(0), {
                    attributes: true,
                });
            }
        }
    }

    mount(selectors) {
        // The following API call is calling this library, which is not
        // documented besides its source code:
        // https://github.com/swiftype/swiftype-autocomplete-jquery
        $(selectors.inputSelector).swiftype({
            engineKey: this.getEngineKey(),
            renderFunction: this.singleItemRenderFunction,
            resultRenderFunction: this.itemListRenderFunction,
            // This function overrides the default dropdownStylesFunction which
            // inlined a bunch of unwanted styles. This way we avoid the use of
            // !important in our stylesheets.
            dropdownStylesFunction: () => ({}),
            suggestionListType: "div",
            suggestionListClass: "autocomplete-item-list",
            resultListSelector: "a",
            autocompleteContainingElement: selectors.autoCompleteSelector,
        });

        this.addEventListeners(selectors);
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/search.js